import React from 'react';
import { CheckIcon } from 'lucide-react';
import { foundingPlans } from '../../data/foundingOffer';
import type { MembershipPlanId } from '../../types/practitionerSignup';
interface MembershipPlansProps {
  selectedPlan: MembershipPlanId | null;
  redirectingPlan: MembershipPlanId | null;
  onChoose: (planId: MembershipPlanId) => void;
}
export function MembershipPlans({
  selectedPlan,
  redirectingPlan,
  onChoose
}: MembershipPlansProps) {
  const busy = redirectingPlan !== null;
  return <ul className="grid gap-5 md:grid-cols-2 xl:grid-cols-4" data-id="element-398" data-mp="1uf57zy90z3kv">
      {foundingPlans.map(plan => {
      const isSelected = selectedPlan === plan.id;
      return <li key={plan.id} className={`relative flex flex-col rounded-2xl px-6 py-7 ${plan.highlighted ? 'border-2 border-purple-600 bg-purple-50' : 'border border-purple-200 bg-white'}`} data-id="element-399" data-mp="23fjuv21n0qqh">
            {plan.highlighted && <span className="absolute -top-3 left-6 rounded-full bg-purple-700 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-white" data-id="element-400" data-mp="3g2j0owha9ac5">
                Most popular
              </span>}

            <h3 className="font-serif text-2xl text-charcoal" data-id="element-401" data-mp="3pz5krj1sbxd4">
              {plan.name}
            </h3>

            <p className="mt-1 text-sm text-charcoal/60" data-id="element-402" data-mp="3us6z9py2xuw6">
              {plan.seats}
            </p>

            <p className="mt-5 font-serif text-3xl text-purple-800" data-id="element-403" data-mp="2mlbhdsac8ff">
              {plan.price}
              <span className="text-base text-purple-800/70" data-id="element-404" data-mp="7kd5cdchq4m9">
                {plan.priceSuffix}
              </span>
            </p>

            <p className="mt-1 text-sm text-charcoal/55" data-id="element-405" data-mp="hk3wq65r83i4">
              Founding rate, from month three
            </p>

            <ul className="mt-6 space-y-2.5" data-id="element-406" data-mp="2ecxcklxu0jhl">
              {plan.features.map(feature => <li key={feature} className="flex items-start gap-2.5 text-sm leading-relaxed text-charcoal/80" data-id="element-407" data-mp="2jayuv4nfoes0">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-purple-700" data-id="element-408" data-mp="2bcm5i8tz1rql" />

                  {feature}
                </li>)}
            </ul>

            <div className="mt-auto pt-8" data-id="element-409" data-mp="2g9ma0fb6amfl">
              <button type="button" id={`choose-plan-${plan.id}`} data-plan-id={plan.id} onClick={() => onChoose(plan.id)} disabled={busy} aria-pressed={isSelected} className={`inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full px-6 py-3.5 text-sm font-semibold transition-colors duration-200 ease-out disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 ${plan.highlighted ? 'bg-purple-700 text-white hover:bg-purple-800 disabled:opacity-70 focus-visible:ring-offset-purple-50' : 'border border-charcoal/25 text-charcoal hover:border-purple-700 hover:text-purple-800 disabled:opacity-60 focus-visible:ring-offset-white'}`} data-id="element-410" data-mp="2g8kpzlc6iplq">
                Choose {plan.name}
              </button>
            </div>
          </li>;
    })}
    </ul>;
}